<template>
  <div class="outlineBox">
    <div class="outlineContent">
        当然可以，以下是一个关于机器人课程的示例课程大纲。这个大纲适用于一个入门级的机器人课程，适合高中生或大学新生。课程内容可以根据具体的教学目标和学生背景进行调整。

---

**机器人课程大纲**

**课程名称：** 机器人基础与应用

**课程描述：**
本课程旨在为学生提供一个关于机器人技术的全面介绍，包括机器人的历史、基础理论、设计原则、编程以及实际应用。学生将通过理论学习和实践操作，了解机器人的工作原理，并能够设计和构建简单的机器人系统。

**课程目标：**
<br/>理解机器人技术的基本概念和原理。
<br/>学习机器人设计和构建的基本技能。
<br/>掌握机器人编程和控制的基本方法。
<br/>了解机器人在不同领域的应用。
<br/>培养创新思维和团队合作能力。

**课程安排：**

**第1周：机器人技术概述**
<br/>机器人的历史与发展
<br/>机器人的定义与分类
<br/>机器人技术的应用领域

**第2周：机器人机械系统**
<br/>机械设计基础
<br/>机器人的驱动系统
<br/>机器人的传感器系统

**第3周：机器人电子系统**
<br/>电子电路基础
<br/>微控制器与编程
<br/>机器人的通信系统

**第4周：机器人编程基础**
<br/>编程语言介绍（如Python、C++）
<br/>控制结构与逻辑
<br/>机器人编程环境与工具

**第5周：机器人运动控制**
<br/>运动学与动力学基础
<br/>路径规划与导航
<br/>实践：编写简单的运动控制程序

**第6周：机器人感知与决策**
<br/>传感器数据的采集与处理
<br/>环境感知与状态估计
<br/>决策制定与行为控制

**第7周：人工智能与机器人**
<br/>机器学习基础
<br/>人工智能在机器人中的应用
<br/>实践：使用机器学习算法进行机器人行为训练

**第8周：机器人系统集成**
<br/>系统集成的挑战与策略
<br/>项目规划与管理
<br/>实践：设计并构建一个简单的机器人系统

**第9周：机器人伦理与社会影响**
<br/>机器人技术对社会的影响
<br/>机器人伦理问题
<br/>讨论：机器人技术的未来与挑战

**第10周：项目展示与评估**
<br/>学生项目展示
<br/>项目评估与反馈
<br/>课程总结与展望

**评估方式：**
<br/>课堂参与（15%）
<br/>作业与实验报告（35%）
<br/>期中项目（20%）
<br/>期末项目（30%）

**预备知识：**
<br/>基本的数学和物理知识
<br/>编程基础（如Python）

**教材与资源：**
<br/>指定教材：《机器人技术基础》
<br/>在线资源：机器人编程教程、开源硬件文档

---

这个大纲提供了一个全面的框架，可以根据具体的教学需求和资源进行调整。希望这对你的课程设计有所帮助！

    </div>
  </div>
</template>
<script>
import { getAction, postAction } from "@/api/manage";
export default {
  props: ["details"],
  watch: {
    details: {
      handler(obj) {
        this.info = obj;
      },
      immediate: true,
      deep: true,
    },
  },
  name: "",
  components: {},
  data() {
    return {
      activeKey:[],
      info: {},
      courseUnitDataSource:[]
    };
  },
  created() {
    this.getData()
  },
  mounted() {},
  methods: {
    getData(){
        console.log(this.$route.query.id , 'id')
        getAction("/teaching/teachingCourseUnit/showCourseUnit", {
          courseId: this.$route.query.id,
        }).then((res) => {
          if (res.success) {
            this.courseUnitDataSource = res.result;
          }
        });
    },
    changeCollapseFn(val){
        console.log(val , 'val')
        getAction("/teaching/teachingCourseUnit/unitMedia?id="+val).then(res=>{
            console.log(res , 'res')
        })
    }
  },
};
</script>
<style lang='less' scoped>
.outlineBox{
    width: 100%;
    max-width: 1200px;
    height: 700px;
    margin: 30px auto;
    background-image: url('~@/theme/wayi/assets/imgs/course/ipd.png');
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .outlineContent{
        padding: 5px 40px;
        border-radius: 30px;
        width: 95%;
        height: 600px;
        overflow-y: auto;
        // background: #fff;
        margin: 30px auto;
        /deep/.ant-collapse > .ant-collapse-item{
            border-color: #ffffff3b !important;
        }
        /deep/.ant-collapse{
            background: transparent !important;
            color: #fff;
            border-color: transparent !important;
           
        }
        /deep/.ant-collapse-header{
                color: #fff !important;
            }
        /deep/.ant-collapse-content{
            background: transparent !important;
            border-color: transparent !important;
        }
    }
}
</style>
